import React, { useState } from "react";
import { GlButton } from "@adl/component-button";
import { GlCallout } from "@adl/component-callout";
import { useTranslations } from "@crystal/translator";
import styles from "../consents.module.scss.js";
import ExplicitConsentCheckBox from "./explicit-consent-checkbox.js";
import { PendingSubscription } from "./pending-subscription.js";
const ExplicitConsentWithPermission = ({ document, onChange, permission }) => {
  const t = useTranslations();
  const [checked, setChecked] = useState(permission.accepted);
  if (!document) {
    return null;
  }
  const {
    document: { link1, link2, documentTitle, documentText1, documentText2, documentText3, documentName, documentType }
  } = document;
  if (permission.permissionType === "flag-mrkt-email" && permission.confirmationStatus === "pending") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, documentTitle && /* @__PURE__ */ React.createElement("h5", { className: styles["pending-explicit-consent-title"] }, documentTitle), /* @__PURE__ */ React.createElement(PendingSubscription, null));
  }
  const patchPermission = (value) => {
    const update = { ...document };
    update.configuration.accepted = value;
    onChange(update);
  };
  const onChangeHandler = ({ target }) => {
    setChecked(target.checked);
    !target.checked && patchPermission(false);
  };
  const onSubmitHandler = () => patchPermission(true);
  const permissionsTitles = {
    "flag-mrkt-paidmedia": "account.preferences.currentlySubscribed.paidmedia",
    "flag-mrkt-sms": "account.preferences.currentlySubscribed.sms"
  };
  const calloutTitle = permissionsTitles[permission == null ? void 0 : permission.permissionType] ?? "account.preferences.currentlySubscribed";
  return /* @__PURE__ */ React.createElement("div", { className: "gl-vspace-bpall-small" }, documentTitle && /* @__PURE__ */ React.createElement("h5", { className: styles["explicit-consent-title"] }, documentTitle), /* @__PURE__ */ React.createElement(
    ExplicitConsentCheckBox,
    {
      name: documentName,
      consent: {
        label: documentText1,
        id: documentType,
        cta: link1,
        close: link2,
        details: [documentText2, documentText3 || ""]
      },
      isChecked: checked,
      onChange: onChangeHandler,
      required: false,
      className: "gl-vspace-bpall-small"
    }
  ), checked && !permission.accepted && /* @__PURE__ */ React.createElement(
    GlButton,
    {
      className: styles["permission-sign-up"],
      "data-auto-id": "permission-sign-up-btn",
      onClick: onSubmitHandler
    },
    t("permission.sign.up.btn")
  ), checked && permission.accepted && /* @__PURE__ */ React.createElement(GlCallout, { className: styles["confirmed-subscription"] }, /* @__PURE__ */ React.createElement("p", { className: styles["confirmed-subscription-title"] }, t(calloutTitle)), /* @__PURE__ */ React.createElement("div", { className: "gl-vspace-bpall-small" }, t("account.preferences.unsubscribe"))));
};
export {
  ExplicitConsentWithPermission as default
};
//# sourceMappingURL=explicit-consent-with-permission.js.map
